import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import BigFloatButton from '../../components/BigFloatButton/BigFloatButton';
import { EmptyListFallback } from '../../components/EmptyListFallback/EmptyListFallback';
import Loader from '../../components/Loader/Loader';
import { OnCallAlertStatus } from '../../components/OnCallAlert/OnCallAlert.styles';
import { OnCallAlertItem } from '../../components/OnCallAlertItem/OnCallAlertItem';
import { Page } from '../../components/Page/Page';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { fetchGroups } from '../GroupsList/groupsSlice/actionCreators';
import { selectUserPermissions } from '../Login/LoginSlice';
import {
  selectOnCallAlertIsLoading,
  selectOnCallAlertList,
  setOnCallAlertDocument,
} from './onCallAlertSlice';
import { fetchOnCallAlertList } from './onCallAlertSlice/actionCreators';

const SPage = styled(Page)`
  padding: 1.25rem 0rem;
  /* to make only the list overflow */
  position: relative;
  height: 100%;
`;

const SList = styled.ul`
  width: 90%;
  margin: auto;

  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: center;

  overflow-y: auto;
  height: calc(100%);

  padding-bottom: 3rem;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const OnCallAlert = () => {
  const dispatch = useAppDispatch();
  const onCallAlertList = useAppSelector(selectOnCallAlertList);
  const isLoading = useAppSelector(selectOnCallAlertIsLoading);

  const userPermissions = useAppSelector(selectUserPermissions);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(setOnCallAlertDocument(null));
    dispatch(fetchOnCallAlertList());
    dispatch(fetchGroups());
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <SPage>
      <SList role="alertsList">
        {onCallAlertList.length ? (
          onCallAlertList.map(item => <OnCallAlertItem key={`${item.id}-+`} onCallAlert={item} />)
        ) : (
          <EmptyListFallback
            listLength={onCallAlertList.length}
            isLoading={false}
            emptyListTx={'onCallAlert_empty'}
          />
        )}
      </SList>
      {userPermissions?.onCallAlert.mayActivate ? (
        <BigFloatButton link={'/startOnCallAlert'} tx={'alarm_start_oncall_alert'} />
      ) : (
        <OnCallAlertStatus role="alertStatus">{t('onCallAlert_start_replacer')}</OnCallAlertStatus>
      )}
    </SPage>
  );
};
